<template>
  <v-row>
    <v-col v-if="config && config.length" class="mx-2">
      <v-expansion-panels focusable>
        <v-expansion-panel
          v-for="(setting, i) in config"
          :key="i"
          ripple
        >
          <v-expansion-panel-header>{{ setting.name }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card class="mt-5" :style="cardStyle">
              <v-row class="mx-0">
                <v-col class="px-4 py-0 mt-6">
                  <app-input
                    data-testid="ace-setting-subject-input"
                    class="ace-setting-subject-input"
                    :type="'text'"
                    label="Subject"
                    :hint="'This is the subject line of the email sent to the customer'"
                    v-model="setting.subject"
                  />
                  <v-textarea
                    data-testid="ace-setting-content-textarea"
                    class="ace-setting-content-textarea"
                    filled
                    clearable
                    label="Content"
                    hint="This is the content of the email sent to the customer"
                    :rules="inputRules"
                    v-model="setting.content"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-col class="px-0 mt-4">
        <v-btn
          data-testid="ace-save-global-configs-btn"
          class="ace-save-global-configs-btn ml-0"
          color="primary"
          :loading="loading"
          :disabled="!canSubmit"
          @click="saveGlobalAceConfigs"
        >
          Save Settings
        </v-btn>
      </v-col>
    </v-col>
    <v-col v-else class="title">
      There are no settings to configure for this email set. If you believe you are seeing this message in error,
      contact support.
    </v-col>
  </v-row>
</template>

<script>
import { inputRules } from "@/helpers/form-rules";

export default {
  props: {
    config: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      loading: false,
      metricDirections: ["before", "after"],
      inputRules: inputRules
    };
  },

  methods: {
    saveGlobalAceConfigs() {
      this.$emit("save-global-ace-configs");
    }
  },

  computed: {
    cardStyle() {
      return this.darkTheme ? { outline: "#757575 solid 1px" } : { outline: "#BDBDBD solid 1px" };
    },
    darkTheme() {
      return this.$vuetify.theme.dark;
    },

    canSubmit() {
      let validSubmission = true;
      this.config.forEach(obj => {
        for (const val in obj) {
          if (typeof obj[val] === "number" && obj[val] >= 0) {
            // is valid, do nothing & keep iterating
          } else if (obj[val]) {
            // is valid, do nothing & keep iterating
          } else {
            validSubmission = false;
          }
        }
      });
      return validSubmission;
    }
  }
};
</script>
